'use client';

import { useMemo } from 'react';

import { Card } from '@entities/card';

import { useGetNotesDynamicDataQuery } from '@shared/api';
import type { Notes } from '@shared/types';

type TProps = {
  data: Notes[] | null;
};

export const Data = ({ data: initialData }: TProps) => {
  const ids = useMemo(() => {
    return initialData?.map(({ id }) => id) || [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { data: curData } = useGetNotesDynamicDataQuery({ ids });

  const data = curData || initialData;

  return data?.map((item) => <Card.GridNote key={item.id} {...item} />);
};
